const DEFAULT_POWERED_VISIBILITY = true;

export {
  DEFAULT_POWERED_VISIBILITY,
};
